export function MoonIcon({ phase, size = 18 }: { phase: number; size?: number }) {
  const dark = '#475569';
  const light = '#f1f5f9';
  const stroke = '#94a3b8';
  const vb = 22;
  const r = 10, cx = 11, cy = 11;

  if (phase < 0.03 || phase >= 0.97) {
    return (
      <svg width={size} height={size} viewBox={`0 0 ${vb} ${vb}`}>
        <circle cx={cx} cy={cy} r={r} fill={dark} stroke={stroke} strokeWidth="1" />
      </svg>
    );
  }
  if (phase >= 0.47 && phase < 0.53) {
    return (
      <svg width={size} height={size} viewBox={`0 0 ${vb} ${vb}`}>
        <circle cx={cx} cy={cy} r={r} fill={light} opacity={0.9} stroke={stroke} strokeWidth="1" />
      </svg>
    );
  }

  const waxing = phase < 0.5;
  const lit = waxing ? phase / 0.5 : (1 - phase) / 0.5;
  const tx = r * Math.cos(lit * Math.PI);
  const atx = Math.abs(tx);
  const terminatorSweep = tx < 0 ? 1 : 0;

  if (waxing) {
    return (
      <svg width={size} height={size} viewBox={`0 0 ${vb} ${vb}`}>
        <circle cx={cx} cy={cy} r={r} fill={dark} stroke={stroke} strokeWidth="1" />
        <path
          d={`M ${cx} ${cy - r} A ${r} ${r} 0 0 1 ${cx} ${cy + r} A ${atx} ${r} 0 0 ${terminatorSweep} ${cx} ${cy - r} Z`}
          fill={light} opacity={0.9}
        />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox={`0 0 ${vb} ${vb}`}>
      <circle cx={cx} cy={cy} r={r} fill={dark} stroke={stroke} strokeWidth="1" />
      <path
        d={`M ${cx} ${cy - r} A ${r} ${r} 0 0 0 ${cx} ${cy + r} A ${atx} ${r} 0 0 ${1 - terminatorSweep} ${cx} ${cy - r} Z`}
        fill={light} opacity={0.9}
      />
    </svg>
  );
}
